import { LightningElement, track, api  } from 'lwc';

export default class sldsTablePaginator extends LightningElement {
    static renderMode = 'light';
    @track _activePage;
    @track _pageMeta;
    @track _pageArr = [];
    
    /*@track options = [
        {label: 'Label 1', value: 1, metaOne: 'Meta One', metaTwo: 'Meta Two'},
        {label: 'Label 2', value: 2, metaOne: 'Meta One', metaTwo: 'Meta Two'},
        {label: 'Label 3', value: 3, metaOne: 'Meta One', metaTwo: 'Meta Two'},
        {label: 'Label 4', value: 4, metaOne: 'Meta One', metaTwo: 'Meta Two'},
        {label: 'Label 5', value: 5, metaOne: 'Meta One', metaTwo: 'Meta Two'},
        {label: 'Label 6', value: 6, metaOne: 'Meta One', metaTwo: 'Meta Two'},
        {label: 'Label 7', value: 7, metaOne: 'Meta One', metaTwo: 'Meta Two'},
        {label: 'Label 8', value: 8, metaOne: 'Meta One', metaTwo: 'Meta Two'},
    ];*/
    
    @track label="Combo Label";

    @api // Display the current pages info
    set activePage(val) {
        this._activePage = parseInt(val) || 1;
    }
    get activePage() {
        return  this._activePage;
    }

    @api // Store all the pages details
    set pageDetails(val) {
        this._pageDetails = val;
        this._pageArr = this.getPageKeys(val);
    }
    get pageDetails() {
        return this._pageDetails;
    }

    @api 
    set pageMeta(val) {
        this._pageMeta = val;
    }
    get pageMeta() {
        return this._pageMeta;
    }

    @api sortedColLabel;


    handleToggleEvent(message) {
        const val = message.detail;
    }

    get comboboxMenuTitle() {
        return this.sortedColLabel
            ? `Pages by ${this.sortedColLabel}`
            : null;
    }

    get currentDetails() {
        return this.pageDetails && this._activePage
            ? this.pageDetails[this._activePage]
            : '';
    }


    // Get all pages in pageDetails (sorted)
    getPageKeys(pageObj=null) {
        if (pageObj) {
            return Object.keys(pageObj)
                .filter(k => !Number.isNaN(parseInt(k)))
                .map(k => parseInt(k))
                .sort((a, b) => a - b);
        }
        return Object.keys(this.pageDetails)
            .filter(k => !Number.isNaN(parseInt(k)))
            .map(k => parseInt(k))
            .sort((a, b) => a - b);
    }

    // Send new page number to parent
    sendNewPageEvt(page) {
        try {
            this.dispatchEvent(new CustomEvent('combometaselection', {
                detail: page,
            }));
        }catch(err) {
            console.error('sendNewPageEvt',err);
        }
    }

    handlePageOne() {
        const page = this._pageArr[0];
        this.sendNewPageEvt(page)
    }
    handlePageLast() {
        const page = this._pageArr[this._pageArr.length -1];
        this.sendNewPageEvt(page)
    }
    handlePagePrev() {
        const crntPageIdx = this._pageArr.findIndex(p => p === this._activePage);
        const page = crntPageIdx - 1 < 0
            ? this._pageArr[this._pageArr.length-1]
            : this._pageArr[crntPageIdx-1];
        this.sendNewPageEvt(page)
    }
    handlePageNext() {
        try {
            const crntPageIdx = this._pageArr.findIndex(p => p === this._activePage);
            console.log('crntPageIdx: ',  crntPageIdx);
            const page = crntPageIdx === -1 
                ? 2 
                    :crntPageIdx + 1 > this._pageArr.length - 1
                ? this._pageArr[0]
                : this._pageArr[crntPageIdx+1];
            this.sendNewPageEvt(page);
        
        }catch(err) {
            console.error('page next', err);
        }
    }


}